import styled from "styled-components";

export const InputWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 3px;
  position: relative;

  /* Contenedor para el input y sus elementos internos */
`;

export const InputInnerWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const InputTitle = styled.span<{ $hidden?: boolean }>`
  font-size: 14px;
  color: ${(props) => props.theme.colors.font.primary};
  display: ${(props) => (props.$hidden ? "none" : "block")};
`;

export const IconContainer = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;

  > svg {
    width: 1.25rem;
    height: 1.25rem;
    color: #989898;
  }
`;

export const StyledInput = styled.input<{
  $indent: boolean;
  $error?: boolean;
  $creamBackground?: boolean;
}>`
  width: 100%;
  height: ${(props) => (props.$indent ? "2.5rem" : "36px")};
  border: 1px solid ${(props) => (props.$error ? "red" : props.$indent ? "#ECECEC" : props.theme.colors.border)};
  border-radius: ${(props) => props.theme.box.borderRadius};
  background-color: ${(props) => {
    if (props.$creamBackground) return "#FEF3C7";
    return props.$indent ? "white" : props.theme.colors.primary;
  }};
  color: ${(props) => (props.$creamBackground ? "#374151" : props.theme.colors.font.primary)};
  padding: ${(props) => (props.$indent ? props.theme.spacing.small : "0 10px")};
  padding-left: ${(props) => (props.$indent ? "2.5rem" : "10px")};
  padding-right: ${(props) => (props.$indent ? props.theme.spacing.small : "10px")};
  box-sizing: border-box;
  font-size: ${(props) => (props.$indent ? "0.875rem" : "inherit")};
  caret-color: ${(props) => (props.$indent ? "inherit" : props.$creamBackground ? "#374151" : props.theme.colors.font.tertiary)};
  &:focus {
    outline: none;
    ${(props) => props.$indent && `
      border-color: ${props.$error ? "red" : "#34d399"};
      box-shadow: 0 0 0 2px rgba(52, 211, 153, 0.1);
    `}
  }
  &::placeholder {
    color: ${(props) => {
      if (props.$creamBackground) return "#6B7280";
      return props.$indent ? "#989898" : props.theme.colors.font.tertiary;
    }};
    opacity: 1;
  }
`;
